// Devices tab — leaf under the SiteLayout. Devices are created via the
// layout-import wizard (button in the SiteLayout tab strip).

import { createFileRoute } from "@tanstack/react-router";

import { DeviceListPanel } from "../features/devices/DeviceListPanel";

export const Route = createFileRoute(
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/devices",
)({
  component: DevicesRoute,
});

function DevicesRoute() {
  const { accountSlug, tenantSlug, siteSlug } = Route.useParams();
  return (
    <DeviceListPanel
      accountSlug={accountSlug}
      tenantSlug={tenantSlug}
      siteSlug={siteSlug}
    />
  );
}
